export function setupAutocomplete() {
  const addresses = jQuery('.autocomplete-us');
  const addressData = {};
  let i = 1;

  if (!addresses.length) {
    return;
  }

  if (!window.onCarrot) {
    window.onCarrot = {};
  }

  addresses.each(function () {
    const address = {};
    const addressID = 'autocomplete-us-' + i;

    // Hide the default full address field set
    jQuery(this).find('.ginput_complex').hide();

    address.street_number = {
      id: jQuery(this).find('.address_line_1 > input').attr('id'),
      value: 'short_name',
    };
    address.route = {
      id: jQuery(this).find('.address_line_2 > input').attr('id'),
      value: 'short_name',
    };
    address.locality = {
      id: jQuery(this).find('.address_city > input').attr('id'),
      value: 'long_name',
    };
    address.administrative_area_level_1 = {
      id: jQuery(this).find('.address_state > select').attr('id'),
      value: 'long_name',
    };
    address.postal_code = {
      id: jQuery(this).find('.address_zip > input').attr('id'),
      value: 'long_name',
    };

    addressData[addressID] = address;

    const placeholder = jQuery(this)
      .find('.address_line_1 input')
      .attr('placeholder');

    // Create the autocomplete field
    const autocompleteInput = jQuery(
      "<input type='text' id='" +
        addressID +
        "' class='ginput_full autocomplete-address' placeholder='" +
        (placeholder ? placeholder : '') +
        "'>"
    );

    // Insert it before the default full field set
    jQuery(this).find('.gfield_label').after(autocompleteInput);

    function chromeForceDisableAutocomplete(el) {
      if (
        navigator.userAgent.indexOf('Chrome') !== -1 &&
        el.getAttribute('autocomplete') === 'off'
      ) {
        el.setAttribute('autocomplete', 'new-password');
      }
    }

    // Prevent pressing enter when selecting an address to submit the form
    jQuery('#' + addressID)
      .keydown(function (e) {
        chromeForceDisableAutocomplete(e.target);

        if (e.keyCode == 13) {
          e.preventDefault();
        }
      })
      .focus(function (e) {
        chromeForceDisableAutocomplete(e.target);
      });

    i++;
  });

  // Add address ID's to main window to be accessible for Google autocomplete functions
  window.onCarrot.addresses = addressData;
}

export const loadGmaps = async () => {
  const { maybeLoadGmaps } = await import(
    '../../../../../../../plugins/oncarrot-map/maybe-load-gmaps.js'
  );

  await maybeLoadGmaps({ jQuery })
    .then(initAutocomplete)
    .catch(function (e) {
      console.log('error loading gmaps in carrot gf address autocomplete');
      throw e;
    });
};

/**
 * Google Places Autocomplete functions
 */
const autocompleteAddresses = {};

export function initAutocomplete() {
  // Create the autocomplete object, restricting the search to geographical
  // location types.
  if (window.onCarrot && window.onCarrot.addresses) {
    const addresses = window.onCarrot.addresses;
    Object.keys(addresses).forEach(function (addressID) {
      const autocomplete = new google.maps.places.Autocomplete(
        document.getElementById(addressID),
        { types: ['geocode'] }
      );

      // When the user selects an address from the dropdown, populate the address
      // fields in the form.
      addAutoCompleteListener(autocomplete, addressID);

      autocompleteAddresses[addressID] = autocomplete;
    });
  }
}

export function addAutoCompleteListener(autocomplete, addressID) {
  autocomplete.addListener('place_changed', function () {
    const place = autocomplete.getPlace();
    fillInAddress(addressID, place);
  });
}

export function fillInAddress(addressID, place) {
  // Get correct form to work with
  const gform_body = jQuery('#' + addressID).closest('.gform_body');

  // Get the place details from the autocomplete object.
  const componentForm = window.onCarrot.addresses;
  for (const component in componentForm[addressID]) {
    gform_body.find('#' + componentForm[addressID][component].id).value = '';
    gform_body.find('#' + componentForm[addressID][component].id).disabled =
      false;
  }

  // Get each component of the address from the place details
  // and fill the corresponding field on the form.
  for (let i = 0; i < place.address_components.length; i++) {
    const addressType = place.address_components[i].types[0];
    if (componentForm[addressID][addressType] && addressType) {
      const val =
        place.address_components[i][
          componentForm[addressID][addressType].value
        ];

      // Street name should be appended to address line 1
      if (addressType == 'route') {
        const streetNumber = gform_body.find(
          '#' + componentForm[addressID]['street_number'].id
        );
        streetNumber.val(streetNumber.val() + ' ' + val);
        streetNumber.trigger('change');
      } else {
        const field = gform_body.find(
          '#' + componentForm[addressID][addressType].id
        );
        field.val(val);
        field.trigger('change');
      }
    }
  }
}

// Bias the autocomplete object to the user's geographical location,
// as supplied by the browser's 'navigator.geolocation' object.
export function geolocate(id) {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(function (position) {
      const geolocation = {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      };
      const circle = new google.maps.Circle({
        center: geolocation,
        radius: position.coords.accuracy,
      });
      autocompleteAddresses[id].setBounds(circle.getBounds());
    });
  }
}
